import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
// import Header from './components/Header';
// import Footer from './components/Footer';
import NavigationBar from './components/NavigationBar';
import Home from './pages/Home';
import './App.css';
import { Login, Signup } from './pages/Login';
// import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Invoice from './pages/Invoice';
import ProductDashboard from './pages/Products';
import Profile from './pages/Porfile';


const App = () => {
  return (
    <Router basename={process.env.PUBLIC_URL}>

      <div className="d-flex flex-column min-vh-100">
        <NavigationBar />
        <div className="App">
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/products" element={<ProductDashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/invoices" element={<Invoice />} />
            </Routes>
          </main>
        </div>
      </div>
    </Router>
  );
};


export default App;


